// Added By : bhautik
// Created At: 28-5-2024
// Description: login slice
// Ticket ID: 001
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  signInUser,
  resetPasswordService,
  forgotpasswordService,
  ResendOtpService,
  signUpUser,
  VerifyEmailApi,
  comapnyRegisterService,
  acceptTerms,
} from "../../Api/services/authService";
import toast from "react-hot-toast";

export const resetPassword = createAsyncThunk(
  "auth/resetPassword",
  async ({ resetCode, newPassword }) => {
    try {
      const response = await resetPasswordService(resetCode, newPassword);
      return response.data;
    } catch (error) {
      return error.response.data;
    }
  }
);

const authSlice = createSlice({
  name: "auth",
  initialState: {
    user: null,
    userData: null,
    error: null,
    selectedCompany: null, // New state for selected company
    loading: false,
    passwordResetStatus: null,
    userProfilePhoto: "",
  },
  reducers: {
    logout: (state) => {
      state.user = null;
      state.error = null;
      state.loading = false;
      state.userProfilePhoto = "";
    },
    SelectedCompany: (state, action) => {
      // document.documentElement.style.setProperty("--primary_orange", action?.payload?.brand_colour);
      // state.selectedCompany = action.payload; // Update selected company
      const updatedCompanyData = action.payload;

      // Merge the updated fields with the existing state
      state.selectedCompany = {
        ...state.selectedCompany, // Keep existing values like token, refresh_token
        ...updatedCompanyData, // Overwrite with the new data from the payload
      };

      // Update the brand color in the document's root
      if (updatedCompanyData?.brand_colour) {
        document.documentElement.style.setProperty(
          "--primary_orange",
          updatedCompanyData.brand_colour
        );
      }
    },
    //when company data update
    updateUserDataByCompanyId: (state, action) => {
      // Check if userData exists and contains companies array
      if (state.userData && Array.isArray(state.userData?.data?.company)) {
        // Find the index of the company to update
        const companyIndex = state.userData?.data?.company.findIndex(
          (company) => company.id === action?.payload?.id
        );

        // If company is found, update its data
        if (companyIndex !== -1) {
          state.userData.data.company[companyIndex] = {
            ...state.userData.data.company[companyIndex], // Keep existing company data
            ...action.payload, // Overwrite with new data
          };
        }
      }
    },
    updateUserProfilePhoto: (state, action) => {
      state.userProfilePhoto = action.payload;
    },
  },

  extraReducers: (builder) => {
    //signin user
    builder
      .addCase(signInUser.pending, (state) => {
        return {
          ...state,
          loading: true,
        };
      })
      .addCase(signInUser.fulfilled, (state, action) => {
        console.log(action.payload, "action");
        if (action?.payload?.success === false) {
          toast.error("error login");
        } else {
          //toast.success(action?.payload?.message);
        }
        return {
          ...state,
          userData: action?.payload,
          userProfilePhoto: action?.payload?.data?.profile_image,
          loading: false,
        };
      })
      // .addCase(signInUser.fulfilled, async (state, action) => {
      //   console.log(action.payload, "action");
      //   if (action?.payload?.success === false) {
      //     toast.error("Error logging in");
      //   } else {
      //     // toast.success(action?.payload?.message);
      //
      //     // Request notification permission after successful login
      //     try {
      //       // TODO get token from notif slice
      //       if (action?.payload?.token) {
      //         console.log("FCM Token: TODO send to BE", action?.payload?.token);
      //         // Send token to backend and associate it with the user
      //         // await sendTokenToBackend(token, action.payload.userId);
      //         // linkFCMToken({ fcm_token: action?.payload?.token });
      //       }
      //     } catch (error) {
      //       toast.error("Failed to get notification permission or token");
      //       console.error(
      //         "Failed to get notification permission or token:",
      //         error
      //       );
      //     }
      //   }
      //   return {
      //     ...state,
      //     userData: action?.payload,
      //     userProfilePhoto: action?.payload?.data?.profile_image,
      //     loading: false,
      //   };
      // })
      .addCase(signInUser.rejected, (state, action) => {
        console.log("action error");
        toast.error(action.payload);
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      });
    //signup user
    builder
      .addCase(signUpUser.pending, (state) => {
        return {
          ...state,
          loading: true,
        };
      })
      .addCase(signUpUser.fulfilled, (state, action) => {
        if (action?.payload?.success === false) {
          toast.error(action.payload);
        } else {
          toast.success(action?.payload?.message);
        }
        return {
          ...state,
          loading: false,
          userData: action?.payload,
        };
      })
      .addCase(signUpUser.rejected, (state, action) => {
        toast.error(action.payload);
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      });
    //company register
    builder
      .addCase(comapnyRegisterService.pending, (state) => {
        return {
          ...state,
          loading: true,
        };
      })
      .addCase(comapnyRegisterService.fulfilled, (state, action) => {
        if (action?.payload?.status === false) {
          toast.error(action?.payload);
        } else {
          toast.success(action?.payload?.message);
        }
        return {
          ...state,
          loading: false,
          //save userData also  in register time
          userData: action?.payload,
        };
      })
      .addCase(comapnyRegisterService.rejected, (state, action) => {
        toast.error(action?.payload);
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      });
    //email verification
    builder
      .addCase(VerifyEmailApi.pending, (state) => {
        return {
          ...state,
          loading: true,
        };
      })
      .addCase(VerifyEmailApi.fulfilled, (state, action) => {
        if (action?.payload?.success === false) {
          toast.error(action.payload);
        } else {
          toast.success(action?.payload?.message);
        }
        return {
          ...state,
          loading: false,
        };
      })
      .addCase(VerifyEmailApi.rejected, (state, action) => {
        toast.error(action.payload);
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      });

    // Reset Password
    builder
      .addCase(resetPasswordService.pending, (state) => {
        return {
          ...state,
          loading: true,
        };
      })
      .addCase(resetPasswordService.fulfilled, (state, action) => {
        if (action?.payload?.status === false) {
          toast.error(action?.payload);
        } else {
          toast.success(action?.payload?.message);
        }
        return {
          ...state,
          loading: false,
        };
      })
      .addCase(resetPasswordService.rejected, (state, action) => {
        toast.error(action?.payload);
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      });

    //forgot password
    builder
      .addCase(forgotpasswordService.pending, (state) => {
        return {
          ...state,
          loading: true,
        };
      })
      .addCase(forgotpasswordService.fulfilled, (state, action) => {
        if (action?.payload?.status === false) {
          toast.error(action?.payload);
        } else {
          toast.success(action?.payload?.message);
        }
        return {
          ...state,
          loading: false,
        };
      })
      .addCase(forgotpasswordService.rejected, (state, action) => {
        toast.error(action?.payload);
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      });
    //resend otp
    builder
      .addCase(ResendOtpService.pending, (state) => {
        return {
          ...state,
          loading: true,
        };
      })
      .addCase(ResendOtpService.fulfilled, (state, action) => {
        if (action?.payload?.status === false) {
          toast.error(action?.payload);
        } else {
          toast.success(action?.payload?.message);
        }
        return {
          ...state,
          loading: false,
        };
      })
      .addCase(ResendOtpService.rejected, (state, action) => {
        toast.error(action?.payload);
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      });

    // Accept Terms
    builder
      .addCase(acceptTerms.pending, (state) => {
        return {
          ...state,
          loading: true,
        };
      })
      .addCase(acceptTerms.fulfilled, (state, action) => {
        if (action?.payload?.success) {
          // Update the terms_accepted status in userData
          toast.success(action?.payload?.message);
          return {
            ...state,
            loading: false,
            userData: {
              ...state.userData,
              data: {
                ...state.userData.data,
                terms_accepted: true,
              },
            },
          };
        } else {
          toast.error(action?.payload?.message);
          return {
            ...state,
            loading: false,
          };
        }
      })
      .addCase(acceptTerms.rejected, (state, action) => {
        toast.error(action?.payload);
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      });
  },
});

export const {
  logout,
  SelectedCompany,
  updateUserDataByCompanyId,
  updateUserProfilePhoto,
} = authSlice.actions;

export default authSlice.reducer;
